import {Component, Input} from '@angular/core';
import {PopupElement} from "../../models/alerts";

@Component({
    selector: 'old-alert',
    templateUrl: './old-alert.component.html',
    styleUrls: ['./old-alert.component.scss']
})
export class OldAlertComponent {
    @Input() item: PopupElement;
    @Input() key: number;
}
